import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import FavoriteSearchesWidget from "app/static/frontend/widgets/components/FavoriteSearchesWidget"

// selectors
import {
    selectWidgetDescription,
    selectWidgetKey,
} from "app/static/frontend/widgets/selectors/selectors"


const mapStateToProps = createStructuredSelector({
    widgetKey: selectWidgetKey,
    description: selectWidgetDescription,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteSearchesWidget)
